import { changeConfirmLocale, getConfirmLocale } from 'antd/es/modal/locale';
export { changeConfirmLocale, getConfirmLocale };
